
import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
  fullHeight?: boolean;
}

const Layout = ({ children, fullHeight = false }: LayoutProps) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className={`w-full ${fullHeight ? 'flex-1 flex' : 'pt-24 pb-12'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
